define(['rest/utils', 'endpoints', 'http', 'security', '../request/requestParamsFactory',
    'services/routing/matrixParameters', 'apiKeyNames'],
function(utils, endpoints, http, security, createRequestParams, matrixParameters, ApiKeyNames) {
    var fields = matrixParameters(), mainPostParamsName = ['origins', 'destinations'];

    function getOptionalBodyParams(postParams) {
        var optionalBodyParamsNames = Object.keys(postParams).filter(function(paramName) {
            return mainPostParamsName.indexOf(paramName) === -1;
        });

        if (!optionalBodyParamsNames.length) {
            return null;
        }

        return optionalBodyParamsNames.reduce(function(accumulator, paramName) {
            accumulator[paramName] = postParams[paramName];
            return accumulator;
        }, {});
    }

    function getBodyParams(postParams) {
        var bodyParams = {
                origins: postParams.origins,
                destinations: postParams.destinations
            },
            optionalBodyParams = getOptionalBodyParams(postParams);

        if (optionalBodyParams) {
            bodyParams.options = {
                post: optionalBodyParams
            };
        }

        return bodyParams;
    }

    return function(maxNoOfElementsInBatchRequest) {
        return function(options, callback) {
            var requestParams = createRequestParams(fields, options),
                queryParams = requestParams.queryParams,
                bodyParams = getBodyParams(requestParams.postParams),
                endpoint;

            queryParams.key = utils.or(options.key, security.getKey(ApiKeyNames.routing));
            queryParams.key = utils.required(queryParams.key);

            endpoint = bodyParams.origins.length * bodyParams.destinations.length <= maxNoOfElementsInBatchRequest ?
                endpoints.matrixSyncRouting : endpoints.matrixRouting;

            http.post({
                url: '{protocol}://' + endpoint,
                queryParameters: queryParams,
                bodyParameters: bodyParams,
                callbackParam: 'callback',
                callback: callback,
                fail: options.fail
            });
        };
    };
});



// WEBPACK FOOTER //
// ./rest/routing/matrixFactory.js